/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Klaviyo back-in-stock: dropdown (select variant first, then retry until trigger appears) or add-to-cart (variant already selected)
document.addEventListener('click', function(event) {
  var btn = event.target && event.target.closest('[data-action="open-back-in-stock"]');
  if (!btn) return;
  event.preventDefault();
  var formId = btn.getAttribute('data-form-id');
  var optionPosition = btn.getAttribute('data-option-position');
  var optionValue = btn.getAttribute('data-option-value');
  if (formId && optionPosition && optionValue) {
    var form = document.getElementById(formId);
    if (form) {
      var optionInput = form.querySelector('[name="option' + optionPosition + '"]') || document.querySelector('[form="' + formId + '"][name="option' + optionPosition + '"]');
      if (optionInput) {
        optionInput.value = optionValue;
        optionInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    var attempts = 0;
    var maxAttempts = 15;
    function tryClick() {
      var bisTrigger = document.querySelector('#klaviyo-bis-button-container button') || document.querySelector('.klaviyo-bis-trigger');
      if (bisTrigger) {
        bisTrigger.click();
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(tryClick, 300);
      }
    }
    setTimeout(tryClick, 500);
  } else {
    var bisTrigger = document.querySelector('#klaviyo-bis-button-container button') || document.querySelector('.klaviyo-bis-trigger');
    if (bisTrigger) bisTrigger.click();
  }
});

// Auto-Add Produkt zum Warenkorb
document.addEventListener('click', async (event) => {
  const target = event.target.closest('[data-auto-add-product]');
  if (!target) return;
  
  event.preventDefault();
  const productHandle = target.dataset.autoAddProduct;
  
  try {
    // Hole Produkt-Daten
    const response = await fetch(`/products/${productHandle}.js`);
    const product = await response.json();
    
    if (product.variants && product.variants[0]) {
      // Füge zum Warenkorb hinzu
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: product.variants[0].id, quantity: 1 }] })
      });
      
      // Aktualisiere Warenkorb
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  } catch (error) {
    console.error('Fehler beim Hinzufügen:', error);
  }
});

// Gutschein-Checkbox Logik: Digital/Physical Umschaltung
(function() {
  // Produkt-Handles definieren
  const DIGITAL_PRODUCT_HANDLE = 'wellington-of-bilmore-giftcard';
  const PHYSICAL_PRODUCT_HANDLE = 'wellington-of-bilmore-geschenkgutschein-brief';
  
  // Zeige/Verstecke Adressfelder basierend auf Checkbox-Status
  function toggleAddressFields(checkbox, addressFields) {
    if (checkbox && addressFields) {
      if (checkbox.checked) {
        addressFields.style.display = 'block';
        // Setze required Attribut wenn Checkbox gecheckt ist
        const textarea = addressFields.querySelector('textarea');
        if (textarea) {
          textarea.required = true;
        }
      } else {
        addressFields.style.display = 'none';
        // Entferne required Attribut wenn Checkbox ungecheckt ist
        const textarea = addressFields.querySelector('textarea');
        if (textarea) {
          textarea.required = false;
          textarea.value = ''; // Lösche Wert wenn ausgeblendet
        }
      }
    }
  }
  
  // Prüfe, ob wir auf einer Gutschein-Produktseite sind
  function initGutscheinCheckbox() {
    const gutscheinCheckboxContainer = document.getElementById('gutscheinCheckbox');
    if (!gutscheinCheckboxContainer) return;
    
    // Finde das Checkbox-Element
    const checkbox = gutscheinCheckboxContainer.querySelector('input[type="checkbox"]');
    if (!checkbox) return;
    
    // Finde das Adressfelder-Container
    const addressFields = document.getElementById('gutscheinAddressFields');
    
    // Aktuelles Produkt-Handle aus der URL ermitteln
    const currentPath = window.location.pathname;
    const isDigitalPage = currentPath.includes(DIGITAL_PRODUCT_HANDLE);
    const isPhysicalPage = currentPath.includes(PHYSICAL_PRODUCT_HANDLE);
    
    // Setze initialen Checkbox-Status basierend auf der aktuellen Seite
    if (isDigitalPage) {
      // Digital-Seite: Checkbox ungecheckt
      checkbox.checked = false;
    } else if (isPhysicalPage) {
      // Physical-Seite: Checkbox gecheckt
      checkbox.checked = true;
    }
    
    // Zeige/Verstecke Adressfelder basierend auf initialem Status
    toggleAddressFields(checkbox, addressFields);
    
    // Event-Listener für Checkbox-Änderungen
    checkbox.addEventListener('change', function() {
      if (isDigitalPage && checkbox.checked) {
        // Auf Digital-Seite: Checkbox wurde gecheckt → Weiterleitung zu Physical
        window.location.href = `/products/${PHYSICAL_PRODUCT_HANDLE}`;
      } else if (isPhysicalPage && !checkbox.checked) {
        // Auf Physical-Seite: Checkbox wurde ungecheckt → Weiterleitung zu Digital
        window.location.href = `/products/${DIGITAL_PRODUCT_HANDLE}`;
      } else {
        // Zeige/Verstecke Adressfelder wenn keine Weiterleitung stattfindet
        toggleAddressFields(checkbox, addressFields);
      }
    });
  }
  
  // Initialisierung beim Laden der Seite
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGutscheinCheckbox);
  } else {
    initGutscheinCheckbox();
  }
})();

// Mobile Menu Tabs
(function() {
  let tabsInitialized = false;

  function initMobileMenuTabs() {
    const mobileMenuDrawer = document.getElementById('mobile-menu-drawer');
    if (!mobileMenuDrawer || tabsInitialized) return;

    const tabs = mobileMenuDrawer.querySelectorAll('.mobile-menu-tab');
    const panels = mobileMenuDrawer.querySelectorAll('.mobile-menu-panel');

    if (tabs.length === 0) return;

    tabsInitialized = true;

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const targetMenu = this.getAttribute('data-menu');

        // Remove active class from all tabs and panels
        tabs.forEach(t => t.classList.remove('mobile-menu-tab--active'));
        panels.forEach(p => p.classList.remove('mobile-menu-panel--active'));

        // Add active class to clicked tab
        this.classList.add('mobile-menu-tab--active');

        // Show corresponding panel
        const targetPanel = mobileMenuDrawer.querySelector(`#${targetMenu}`);
        if (targetPanel) {
          targetPanel.classList.add('mobile-menu-panel--active');
        }
      });
    });
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', initMobileMenuTabs);

  // Re-initialize when mobile menu opens (in case content is dynamically loaded)
  document.addEventListener('mobile-nav:open', function() {
    tabsInitialized = false;
    setTimeout(initMobileMenuTabs, 100);
  });
})();